/*
Documentation

*** make sure to declare all action types in actions.js one folder level back

*/

import * as actionTypes from '../../actions';

const initialState = {
    lead_sources: [],
}

const reducer = (state = initialState, action) => {

    switch (action.type) {

        case actionTypes.SET_LEAD_SOURCES:

            return {
                ...state,
                lead_sources: action.payload.data,
            }

        default: return state;

    }

}

export default reducer;
